/**
 * Created by mark on 05/03/2018.
 */


import React  from 'react';
import {Card , Tabs , Tab  , Nav , NavItem , Form , Row , Col   , Button} from 'react-bootstrap';
import FieldGroup from '../FieldGroup.js';
import Switch from "react-switch";

export default class NotificationsAndMarketing extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            privacy:[
                {text:'Product News'},
                {text:'Invitations'},
                {text:'Promotions'},
                {text:'Urgent Messages & Notifications'},
                {text:'Assignment   Notifications'},
                {text:'Permissions  Notifications'},
                {text:'Subscription Notifications'},
            ]
        }

    }

    handleChange(){

    }

    render() {

        let options = [];

        for(var idx = 0; idx < this.state.privacy.length; idx++)
        {
            options.push(
                <Row style={{paddingRight:"20px"  , paddingTop:"15px"}}>
                    <Col md={6}>
                        {this.state.privacy[idx].text}
                    </Col>
                    <Col md={6}>
                        <label className="float-right">
                            <Switch onChange={this.handleChange} checked={this.state.checked} />
                        </label>
                    </Col>
                </Row>
            );

            options.push(<hr/>)
        }

        return <div>
                <Row>
                    <Col md={12}>
                        <h5>Notifications and marketing preferences for:</h5>
                        <h6><b>Mark James Smith</b>&nbsp;&nbsp;&nbsp;mark@languagenut.com</h6>
                    </Col>
                </Row>
                <br/>
                <Row>
                    <Col md={12}>
                       <p>Please update the subscription list below to reflect the information you would like to receive from us in the future and press confirm</p>
                    </Col>
                </Row>
            <br/>
                {options}
            <br/>
                <Row>
                    <Col md={6}>
                        <a href="#">Privacy statement</a>
                    </Col>
                    <Col md={6}>
                        <Button className="float-right"> Confirm</Button>
                    </Col>
                </Row>
        </div>;
    }

}